function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
import React from "react";
import PropTypes from "prop-types";
import { jsx as ___EmotionJSX } from "@emotion/core";
var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "13o7eu2",
  styles: "display:block;"
} : {
  name: "13o7eu2",
  styles: "display:block;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9pY29ucy9zdG9wd2F0Y2gtYWx0LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU1NIiwiZmlsZSI6Ii4uLy4uLy4uL3NyYy9pY29ucy9zdG9wd2F0Y2gtYWx0LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gXCJyZWFjdFwiO1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tIFwicHJvcC10eXBlc1wiO1xuXG5mdW5jdGlvbiBTdG9wd2F0Y2hBbHQoeyBzaXplLCBwcmltYXJ5Q29sb3IsIHRlc3RJZCB9KSB7XG4gIHJldHVybiAoXG4gICAgPHN2Z1xuICAgICAgY3NzPXt7XG4gICAgICAgIGRpc3BsYXk6IFwiYmxvY2tcIixcbiAgICAgIH19XG4gICAgICB3aWR0aD17c2l6ZX1cbiAgICAgIGhlaWdodD17c2l6ZX1cbiAgICAgIHZpZXdCb3g9XCIwIDAgMzIgMzJcIlxuICAgICAgZm9jdXNhYmxlPVwiZmFsc2VcIlxuICAgICAgcm9sZT1cImltZ1wiXG4gICAgICBhcmlhLWxhYmVsPVwiU3RvcHdhdGNoIGFsdFwiXG4gICAgICBkYXRhLXRlc3RpZD17dGVzdElkfVxuICAgID5cbiAgICAgIDxwYXRoXG4gICAgICAgIGQ9XCJNMTYgNmM1LjUyMyAwIDEwIDQuNDc3IDEwIDEwIDAgNS41MjItNC40NzcgMTAtMTAgMTAtNS41MjIgMC0xMC00LjQ3OC0xMC0xMCAwLTUuNTIzIDQuNDc4LTEwIDEwLTEwem0wIDJjLTQuNDExIDAtOCAzLjU4OC04IDggMCA0LjQxMSAzLjU4OSA4IDggOHM4LTMuNTg5IDgtOGMwLTQuNDEyLTMuNTg5LTgtOC04em0wIDJhMSAxIDAgMDEuOTkzLjg4M0wxNyAxMXY0LjU4NmwzLjI0MyAzLjI0MmEuOTk5Ljk5OSAwIDAxLTEuMzEyIDEuNTA0bC0uMTAyLS4wOS0zLjUzNS0zLjUzNGEuOTkuOTkgMCAwMS0uMjg1LS41NzhMMTUgMTZ2LTVhMSAxIDAgMDExLTF6bTMtOGExIDEgMCAxMTAgMmgtNmExIDEgMCAxMTAtMnpcIlxuICAgICAgICBmaWxsPXtwcmltYXJ5Q29sb3J9XG4gICAgICAvPlxuICAgIDwvc3ZnPlxuICApO1xufVxuXG5TdG9wd2F0Y2hBbHQucHJvcFR5cGVzID0ge1xuICBzaXplOiBQcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWQsXG4gIHByaW1hcnlDb2xvcjogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICB0ZXN0SWQ6IFByb3BUeXBlcy5zdHJpbmcsXG59O1xuXG5leHBvcnQgZGVmYXVsdCBTdG9wd2F0Y2hBbHQ7XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
function StopwatchAlt(_ref) {
  var size = _ref.size,
    primaryColor = _ref.primaryColor,
    testId = _ref.testId;
  return ___EmotionJSX("svg", {
    css: _ref2,
    width: size,
    height: size,
    viewBox: "0 0 32 32",
    focusable: "false",
    role: "img",
    "aria-label": "Stopwatch alt",
    "data-testid": testId
  }, ___EmotionJSX("path", {
    d: "M16 6c5.523 0 10 4.477 10 10 0 5.522-4.477 10-10 10-5.522 0-10-4.478-10-10 0-5.523 4.478-10 10-10zm0 2c-4.411 0-8 3.588-8 8 0 4.411 3.589 8 8 8s8-3.589 8-8c0-4.412-3.589-8-8-8zm0 2a1 1 0 01.993.883L17 11v4.586l3.243 3.242a.999.999 0 01-1.312 1.504l-.102-.09-3.535-3.534a.99.99 0 01-.285-.578L15 16v-5a1 1 0 011-1zm3-8a1 1 0 110 2h-6a1 1 0 110-2z",
    fill: primaryColor
  }));
}
StopwatchAlt.propTypes = {
  size: PropTypes.string.isRequired,
  primaryColor: PropTypes.string.isRequired,
  testId: PropTypes.string
};
export default StopwatchAlt;